import { useAppActions } from 'reducers/slices/buyer/loanOfficers/bidRequestsSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const { createBidRequest } = useAppActions();
  const { bidRequestCreatingStatus } = useSelector(state => state.buyerLoanOfficersBidRequestsSlice);

  return {
    createBidRequest,
    isBidRequestCreating: useFetchStatus(bidRequestCreatingStatus).isPending,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/buyer/loanOfficers/useBidRequests.js